// extracted by mini-css-extract-plugin
export default {"container":"filter-chips_container__CWLu9","chip":"filter-chips_chip__kZO1q","selected":"filter-chips_selected__9zFKr","compact":"filter-chips_compact__-TikJ"};